import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palette-1"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15.8889 6.9375C15.8889 9.11212 14.1477 10.875 12 10.875C9.8522 10.875 8.11108 9.11212 8.11108 6.9375C8.11108 4.76288 9.8522 3 12 3C14.1477 3 15.8889 4.76288 15.8889 6.9375Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M9.77778 17.0625C9.77778 19.2371 8.03666 21 5.88889 21C3.74111 21 2 19.2371 2 17.0625C2 14.8879 3.74111 13.125 5.88889 13.125C8.03666 13.125 9.77778 14.8879 9.77778 17.0625Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21.9999 17.0625C21.9999 19.2371 20.2588 21 18.1111 21C15.9633 21 14.2222 19.2371 14.2222 17.0625C14.2222 14.8879 15.9633 13.125 18.1111 13.125C20.2588 13.125 21.9999 14.8879 21.9999 17.0625Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M15.8889 6.9375C15.8889 9.11212 14.1477 10.875 12 10.875C9.8522 10.875 8.11108 9.11212 8.11108 6.9375C8.11108 4.76288 9.8522 3 12 3C14.1477 3 15.8889 4.76288 15.8889 6.9375Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M9.77778 17.0625C9.77778 19.2371 8.03666 21 5.88889 21C3.74111 21 2 19.2371 2 17.0625C2 14.8879 3.74111 13.125 5.88889 13.125C8.03666 13.125 9.77778 14.8879 9.77778 17.0625Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21.9999 17.0625C21.9999 19.2371 20.2588 21 18.1111 21C15.9633 21 14.2222 19.2371 14.2222 17.0625C14.2222 14.8879 15.9633 13.125 18.1111 13.125C20.2588 13.125 21.9999 14.8879 21.9999 17.0625Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Palette1 = Vue.extend<IconProps>({
  name: 'Palette1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palette-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Palette1;
